/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarksDraftsDto } from '../../models/survey-marks-drafts-dto';

export interface GetSurveyMarkDraft$Params {
  draftId: number;
}

export function getSurveyMarkDraft(
  http: HttpClient,
  rootUrl: string,
  params: GetSurveyMarkDraft$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksDraftsDto>> {
  const rb = new RequestBuilder(rootUrl, getSurveyMarkDraft.PATH, 'get');
  if (params) {
    rb.path('draftId', params.draftId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksDraftsDto>;
      }),
    );
}

getSurveyMarkDraft.PATH = '/me/surveyMarks/drafts/{draftId}';
